import { render, staticRenderFns } from "./CasualDownload.vue?vue&type=template&id=c2262026&scoped=true&"
import script from "./CasualDownload.vue?vue&type=script&lang=js&"
export * from "./CasualDownload.vue?vue&type=script&lang=js&"
import style0 from "./CasualDownload.vue?vue&type=style&index=0&id=c2262026&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2262026",
  null
  
)

export default component.exports